import React, { useState } from 'react';

import { Button, Container, TextField, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  textField: {
    '& textarea': {
      height: '100% !important',
      minHeight: '220px',
      overflowY: 'auto',
    },

    marginBottom: '2rem',
    width: '85%',
  },
}));

export default ({ onApplyChange, text }) => {
  const [value, setValue] = useState(text);
  const classes = useStyles();
  const handleTextChange = (event) => setValue(event.target.value);

  return (
    <Container style={{ textAlign: 'center', width: '70vw' }} className="py-2">
      <Typography className="page-header mb-1">Global video Introduction</Typography>
      <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <Typography className="body-copy mb-1" style={{ width: '300px' }}>
          This text will be what all patients will receive as an introduction to their video reports{' '}
        </Typography>
      </div>
      <div>
        <TextField
          value={value}
          InputProps={{
            style: { color: '#999999', fontSize: '12px', fontWeight: '400', lineHeight: '20px' },
          }}
          multiline
          rows={6}
          rowsMax={20}
          onChange={(event) => handleTextChange(event)}
          variant="outlined"
          className={classes.textField}
        />
      </div>
      <Button color="primary" variant="contained" onClick={() => onApplyChange(value)}>
        Apply change
      </Button>
    </Container>
  );
};
